// Employee model

function layout() {
  let ctxView = {
    model: "company.employee",
    selectable: "multi", // options: multi - one - false
    activeSearch: true,
    limit: 100,
    pagination: false,
    table_action: [],
    fields: {
      code: { type: "char" },
      party: { type: "many2one", model: "party.party", searchable: true },
      section: { type: "many2one", model: "staff.section", searchable: true },
      position: { type: "many2one", model: "staff.position", searchable: true },
      contracting_state: { type: "selection" },
    },
    list: [
      { name: "party", width: "50%" },
      { name: "position", width: "30%" },
      { name: "code", width: "10%" },
    ],
    form: [],
  };
  return ctxView;
}

export { layout };
